<template lang="pug">
  svg( xmlns="http://www.w3.org/2000/svg"
       viewBox="0 0 24 24"
       role="img"
       aria-hidden="true"
       class="icon--svg")
    path(:d="icon")
</template>

<script>
export default {
name: "IconMdi",
  props: ['icon']
}
</script>

<style scoped>
  .icon--svg{
    fill: currentColor;
  }
</style>